/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TakerMock, TakerMockInterface } from "../TakerMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "dex",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "enum INFTAuctionsFeature.NFTAuctionKind",
                name: "auctionKind",
                type: "uint8",
              },
              {
                internalType: "enum INFTAuctionsFeature.NFTKind",
                name: "nftKind",
                type: "uint8",
              },
              {
                internalType: "bool",
                name: "earlyMatch",
                type: "bool",
              },
              {
                internalType: "address",
                name: "maker",
                type: "address",
              },
              {
                internalType: "uint128",
                name: "startTime",
                type: "uint128",
              },
              {
                internalType: "uint128",
                name: "endTime",
                type: "uint128",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "erc20Token",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "startErc20TokenAmount",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "endOrReservedErc20TokenAmount",
                type: "uint256",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "isMatcher",
                    type: "bool",
                  },
                  {
                    internalType: "address",
                    name: "recipient",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "amountOrRate",
                    type: "uint256",
                  },
                  {
                    internalType: "bytes",
                    name: "feeData",
                    type: "bytes",
                  },
                ],
                internalType: "struct INFTAuctionsFeature.AuctionFee[]",
                name: "fees",
                type: "tuple[]",
              },
              {
                internalType: "address",
                name: "nftToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "nftTokenId",
                type: "uint256",
              },
              {
                internalType: "uint128",
                name: "nftTokenAmount",
                type: "uint128",
              },
            ],
            internalType: "struct INFTAuctionsFeature.NFTAuction",
            name: "auction",
            type: "tuple",
          },
          {
            internalType: "address",
            name: "bidMaker",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "erc20TokenAmount",
            type: "uint256",
          },
        ],
        internalType: "struct INFTAuctionsFeature.EnglishAuctionBid",
        name: "enBid",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum INFTAuctionsFeature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct INFTAuctionsFeature.Signature",
        name: "auctionSig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum INFTAuctionsFeature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct INFTAuctionsFeature.Signature",
        name: "bidSig",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "unwrapNativeToken",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "takerCallbackData",
        type: "bytes",
      },
    ],
    name: "acceptBidTestDirect",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "enum INFTAuctionsFeature.NFTAuctionKind",
            name: "auctionKind",
            type: "uint8",
          },
          {
            internalType: "enum INFTAuctionsFeature.NFTKind",
            name: "nftKind",
            type: "uint8",
          },
          {
            internalType: "bool",
            name: "earlyMatch",
            type: "bool",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "startTime",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "endTime",
            type: "uint128",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "erc20Token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "startErc20TokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endOrReservedErc20TokenAmount",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bool",
                name: "isMatcher",
                type: "bool",
              },
              {
                internalType: "address",
                name: "recipient",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "amountOrRate",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "feeData",
                type: "bytes",
              },
            ],
            internalType: "struct INFTAuctionsFeature.AuctionFee[]",
            name: "fees",
            type: "tuple[]",
          },
          {
            internalType: "address",
            name: "nftToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nftTokenId",
            type: "uint256",
          },
          {
            internalType: "uint128",
            name: "nftTokenAmount",
            type: "uint128",
          },
        ],
        internalType: "struct INFTAuctionsFeature.NFTAuction",
        name: "dutchAuction",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum INFTAuctionsFeature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct INFTAuctionsFeature.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "bidAmount",
        type: "uint128",
      },
      {
        internalType: "bytes",
        name: "callbackData",
        type: "bytes",
      },
    ],
    name: "bidNFTDutchAuctionTest",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "enum INFTAuctionsFeature.NFTAuctionKind",
            name: "auctionKind",
            type: "uint8",
          },
          {
            internalType: "enum INFTAuctionsFeature.NFTKind",
            name: "nftKind",
            type: "uint8",
          },
          {
            internalType: "bool",
            name: "earlyMatch",
            type: "bool",
          },
          {
            internalType: "address",
            name: "maker",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "startTime",
            type: "uint128",
          },
          {
            internalType: "uint128",
            name: "endTime",
            type: "uint128",
          },
          {
            internalType: "uint256",
            name: "nonce",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "erc20Token",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "startErc20TokenAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endOrReservedErc20TokenAmount",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "bool",
                name: "isMatcher",
                type: "bool",
              },
              {
                internalType: "address",
                name: "recipient",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "amountOrRate",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "feeData",
                type: "bytes",
              },
            ],
            internalType: "struct INFTAuctionsFeature.AuctionFee[]",
            name: "fees",
            type: "tuple[]",
          },
          {
            internalType: "address",
            name: "nftToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "nftTokenId",
            type: "uint256",
          },
          {
            internalType: "uint128",
            name: "nftTokenAmount",
            type: "uint128",
          },
        ],
        internalType: "struct INFTAuctionsFeature.NFTAuction",
        name: "dutchAuction",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum INFTAuctionsFeature.SignatureType",
            name: "signatureType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "v",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "r",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "s",
            type: "bytes32",
          },
        ],
        internalType: "struct INFTAuctionsFeature.Signature",
        name: "signature",
        type: "tuple",
      },
      {
        internalType: "uint128",
        name: "bidAmount",
        type: "uint128",
      },
      {
        internalType: "bytes",
        name: "callbackData",
        type: "bytes",
      },
    ],
    name: "bidNFTDutchAuctionTestDirect",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "cumulatedFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "migrate",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "myStorage",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "feeData",
        type: "bytes",
      },
    ],
    name: "receiveZeroExFeeCallback",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC721",
        name: "collection",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "retrieveERC721",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "erc1155",
        type: "address",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "callbackData",
        type: "bytes",
      },
    ],
    name: "zeroExTakerCallback",
    outputs: [
      {
        internalType: "bytes4",
        name: "success",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class TakerMock__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    dex: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TakerMock> {
    return super.deploy(dex, overrides || {}) as Promise<TakerMock>;
  }
  getDeployTransaction(
    dex: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(dex, overrides || {});
  }
  attach(address: string): TakerMock {
    return super.attach(address) as TakerMock;
  }
  connect(signer: Signer): TakerMock__factory {
    return super.connect(signer) as TakerMock__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TakerMockInterface {
    return new utils.Interface(_abi) as TakerMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TakerMock {
    return new Contract(address, _abi, signerOrProvider) as TakerMock;
  }
}
